import { Link, useLocation } from 'react-router-dom';
import { 
    STUDY_OPTIONS_PATH, 
    SUGAR_HONEYCOMBS, 
    GONG_GI_PATH, 
    HIDE_AND_SEEK_PATH,
    MARBLES,
    MINGLE_PATH,
    FLYING_STONE_PATH,
    RED_LIGHT_GREEN_LIGHT_PATH,
    TUG_OF_WAR_PATH,
    JEGI_PATH,
    JUMP_ROPE_PATH
} from '../../constants';
import './StudyOptionsPage.css';

const game_to_path = {
    'Hide and Seek': HIDE_AND_SEEK_PATH,
    'Sugar Honeycombs': SUGAR_HONEYCOMBS,
    'Gong Gi': GONG_GI_PATH,
    'Marbles': MARBLES,
    'Mingle': MINGLE_PATH,
    'Flying Stone': FLYING_STONE_PATH,
    'Red Light Green Light': RED_LIGHT_GREEN_LIGHT_PATH,
    'Tug of War': TUG_OF_WAR_PATH,
    'Jegi': JEGI_PATH,
    'Jump Rope': JUMP_ROPE_PATH
}

const categories_to_games = {
    'Listening': ['Hide and Seek', 'Sugar Honeycombs', 'Gong Gi'],
    'Grammar': ['Marbles', 'Mingle', 'Flying Stone'],
    'Vocabulary': ['Jump Rope','Red Light Green Light', 'Tug of War', 'Jegi']
}

export default function GameOptionsPage() {
    const location = useLocation();
    const unit = location.state.unit;
    const category = location.state.category;

    return (
        <div id='study-options-page-container'>
            <div className='white-background'>
                <h1>{unit.name} {category}</h1>
                <div className='study-options-grid'>
                    {categories_to_games[category].map((game) => (
                        <Link to={game_to_path[game]} state={{unit: unit, category: category }} key={game}>
                            <button className='study-option-button'>
                                {game}
                            </button>
                        </Link>
                    ))}

                </div>
                <Link to={STUDY_OPTIONS_PATH} state={unit}>
                    <button className='back-button'>
                        {'Back'}
                    </button>
                </Link>
            </div>
        </div>
    );
}
